// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3d0747b","455":"4971f9a9"}[chunkId] + ".chunk.js";
};